var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "enquirycontainer" }, [
      _c(
        "form",
        {
          staticClass: "enquiryForm",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSendEnquiry.apply(null, arguments)
            },
          },
        },
        [
          _vm.form.isSubmitted
            ? _c("div", { staticClass: "message" }, [
                _c("p", { staticClass: "header" }, [
                  _vm._v("Your enquiry has been sent."),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "subheader" }, [
                  _vm._v(
                    "Thank you for your enquiry. We will endeavour to get back to you as soon as possible. Please keep an eye on your inbox for our response."
                  ),
                ]),
              ])
            : _vm.form.isLoading
            ? _c("div", [_vm._m(1)])
            : _c("fieldset", [
                _vm.form.isSubmittedWithError
                  ? _c("div", { staticClass: "errormessage" }, [
                      _c("p", [
                        _vm._v("Error sending email, please try again."),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "enquiryFormFields" },
                  [
                    _c(
                      "label",
                      { staticClass: "label", attrs: { for: "connote" } },
                      [_vm._v("Connnote number")]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "field",
                        attrs: { type: "text", id: "connote" },
                      },
                      [_vm._v(_vm._s(_vm.form.connote))]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "label", attrs: { for: "companyName" } },
                      [_vm._v("Contact details")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.companyName,
                          expression: "form.companyName",
                        },
                      ],
                      staticClass: "field",
                      attrs: {
                        type: "text",
                        id: "companyName",
                        required: "",
                        placeholder: "Company name*",
                        oninvalid:
                          "this.setCustomValidity('Company name is required')",
                        oninput: "this.setCustomValidity('')",
                      },
                      domProps: { value: _vm.form.companyName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "companyName", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.contactName,
                          expression: "form.contactName",
                        },
                      ],
                      staticClass: "field",
                      attrs: {
                        type: "text",
                        id: "contactName",
                        required: "",
                        placeholder: "Contact name*",
                        oninvalid:
                          "this.setCustomValidity('Contact name is required')",
                        oninput: "this.setCustomValidity('')",
                      },
                      domProps: { value: _vm.form.contactName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "contactName", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.email,
                          expression: "form.email",
                        },
                      ],
                      staticClass: "field",
                      attrs: {
                        type: "email",
                        id: "email",
                        required: "",
                        placeholder: "Email*",
                        oninvalid:
                          "this.setCustomValidity('Email is required')",
                        oninput: "this.setCustomValidity('')",
                      },
                      domProps: { value: _vm.form.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "email", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "label",
                        attrs: { for: "preferredContactMethodEmail" },
                      },
                      [_vm._v("Preferred contact method")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.isPreferredContactMethodEmail,
                            expression: "form.isPreferredContactMethodEmail",
                          },
                        ],
                        staticClass: "field",
                        attrs: {
                          id: "preferredContactMethodEmail",
                          required: "",
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "isPreferredContactMethodEmail",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v("Email"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("Telephone"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.telephone,
                          expression: "form.telephone",
                        },
                      ],
                      staticClass: "field",
                      style: {
                        display: _vm.form.isPreferredContactMethodEmail
                          ? "none"
                          : "block",
                      },
                      attrs: {
                        type: "text",
                        id: "telephone",
                        required: !_vm.form.isPreferredContactMethodEmail,
                        placeholder: "Telephone*",
                        oninvalid:
                          "this.setCustomValidity('Telephone is required')",
                        oninput: "this.setCustomValidity('')",
                      },
                      domProps: { value: _vm.form.telephone },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "telephone", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "label", attrs: { for: "enquiryType" } },
                      [_vm._v("Enquiry Details")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.enquiryType,
                            expression: "form.enquiryType",
                          },
                        ],
                        staticClass: "field",
                        attrs: { id: "enquiryType", required: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "enquiryType",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v("Select the subject of the enquiry")]
                        ),
                        _vm._v(" "),
                        _c("option", [_vm._v("Overdue Delivery")]),
                        _vm._v(" "),
                        _c("option", [_vm._v("Redirection")]),
                        _vm._v(" "),
                        _c("option", [_vm._v("Redelivery")]),
                        _vm._v(" "),
                        _c("option", [_vm._v("Partial Delivery")]),
                        _vm._v(" "),
                        _c("option", [_vm._v("Other")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.enquiryDetails,
                          expression: "form.enquiryDetails",
                        },
                      ],
                      staticClass: "message",
                      attrs: {
                        id: "enquiryDetails",
                        required: "",
                        placeholder: "Message*",
                        oninvalid:
                          "this.setCustomValidity('Message is required')",
                        oninput: "this.setCustomValidity('')",
                      },
                      domProps: { value: _vm.form.enquiryDetails },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.form,
                            "enquiryDetails",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "privacyContainer" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.termsState,
                            expression: "form.termsState",
                          },
                        ],
                        staticClass: "privacyCheck",
                        attrs: {
                          type: "checkbox",
                          id: "terms",
                          required: "",
                          oninvalid:
                            "this.setCustomValidity('Confirm you have read the privacy policy and terms of use')",
                          oninput: "this.setCustomValidity('')",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.termsState)
                            ? _vm._i(_vm.form.termsState, null) > -1
                            : _vm.form.termsState,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.termsState,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "termsState",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "termsState",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "termsState", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(3),
                    ]),
                    _vm._v(" "),
                    _c("vue-recaptcha", {
                      ref: "recaptcha",
                      attrs: {
                        sitekey: this.sitekey,
                        loadRecaptchaScript: true,
                      },
                      on: {
                        verify: _vm.onCaptchaVerified,
                        expired: _vm.onCaptchaExpired,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mb-2 btn-enquiry",
                        attrs: { type: "submit" },
                      },
                      [_vm._v("Lodge Enquiry")]
                    ),
                  ],
                  1
                ),
              ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headercontainer" }, [
      _c("label", { staticClass: "header" }, [_vm._v("Lodge an enquiry")]),
      _vm._v(" "),
      _c("label", { staticClass: "subheader" }, [
        _vm._v("Find out more about what's happening with your consignment."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader" }, [
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__bar" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__ball" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "privacy" }, [
      _vm._v(
        "\n                        Your privacy is important to us. When you contact us, information collected by Freight Management Holdings Pty Ltd (ACN 144 724 532) and its group entities including efm Logistics Services Group Pty Ltd (ACN 144 724 685) and Flip Group Technologies Pty Ltd (ACN 607 246 042) (efm, us, we, our) will be used and held by us for the purposes of contacting you in response to your query and otherwise as specified in our "
      ),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://www.efmlogistics.com.au/privacy",
          },
        },
        [_vm._v("privacy policy")]
      ),
      _vm._v(
        ". If you choose not to provide this information, we may not be able to respond to your query. To access or change your information, please contact us using the details set out in our "
      ),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://www.efmlogistics.com.au/privacy",
          },
        },
        [_vm._v("privacy policy")]
      ),
      _vm._v(".\n                    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "privacyText", attrs: { for: "terms" } },
      [
        _vm._v("I have read and accept the "),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://oneflo.com.au/portal-terms/",
            },
          },
          [_vm._v("Terms of Use")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }